export const NAME = 'productQuote';